import { ConfiguracionUsuarioType } from '@/app/autenticacion/types/ConfiguracionUsuarioType';
import { IniciarSesionOutputType, IniciarSesionType } from '@/app/autenticacion/types/InicarSesionType';
import { MenuType } from '@/app/autenticacion/types/MenuType';
import { RefreshTokenType } from '@/app/autenticacion/types/RefreshTokenType';
import { AxiosResponse } from 'axios';
import { AxiosClient, HttpMethods } from '../../../config/axiosClient';
import { IResponse } from '../../../services/response';
import { CerrarSesionType } from '../types/cerrarSesionType';

class AutenticacionService {
  protected readonly instance: AxiosClient;

  constructor() {
    this.instance = new AxiosClient();
  }

  public iniciarSesion(data: IniciarSesionType) {
    return this.instance.request<AxiosResponse<IResponse<IniciarSesionOutputType>>>(HttpMethods.POST, '/Autenticacion/IniciarSesion', data, {});
  }

  public recuperarContrasenia(correo: string) {
    return this.instance.request<AxiosResponse<IResponse<boolean>>>(HttpMethods.POST, `/Autenticacion/RecuperarContrasenia`, { correo }, {});
  }

  public cambioContrasenia(contraseniaNueva: string) {
    return this.instance.request<AxiosResponse<IResponse<boolean>>>(HttpMethods.PATCH, `/Autenticacion/CambioContrasenia`, { contraseniaNueva }, {});
  }

  public guardarConfiguracionSeguridad(data: ConfiguracionUsuarioType) {
    return this.instance.request<AxiosResponse<IResponse<boolean>>>(HttpMethods.PATCH, `/Autenticacion/GuardarConfiguracionSeguridad`, data, {});
  }

  public validarPermiso(codigoAcceso: string[]) {
    return this.instance.request<AxiosResponse<any>>(HttpMethods.POST, `/Autenticacion/ValidarPermiso`, codigoAcceso, {});
  }

  public obtenerMenu() {
    return this.instance.request<AxiosResponse<IResponse<MenuType[]>>>(HttpMethods.GET, `/Autenticacion/ObtenerMenu`, null, {});
  }

  public registrarFCMToken(token: string) {
    return this.instance.request<AxiosResponse<IResponse<boolean>>>(HttpMethods.POST, `/Autenticacion/RegistrarFCMTokenWeb`, { token });
  }

  public renovarSesion(refreshToken: string) {
    return this.instance.request<AxiosResponse<IResponse<RefreshTokenType>>>(HttpMethods.POST, '/Autenticacion/RenovarSesion', { refreshToken });
  }

  public cerrarSesion(model: CerrarSesionType) {
    return this.instance.request<AxiosResponse<IResponse<boolean>>>(HttpMethods.POST, '/Autenticacion/CerrarSesion', model);
  }
}

export const autenticacionService = new AutenticacionService();
